function openHaitari(ele) {

  let currentOpen = jQuery(ele).parent().hasClass('open');

  jQuery('.haitari').each(function() {
    jQuery(this).removeClass('open');
  })

  if (!currentOpen) {
    jQuery(ele).parent().addClass('open');
  }
  
}
